module.exports = __webpack_public_path__ + "static/media/Boing-Bold_0.fa9dd496.ttf";